import axios from 'axios';
import { ProNotification } from '../antd';
import { goLogin, } from './loginUtils';
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import { ACCESS_TOKEN_KEY, LAST_REQUEST_KEY, } from '../constants/localStorage';

/** Axios or Request */
const request = axios.create();
/** 屏蔽错误提示的接口 */
const MASKING_ERROR_API: string[] = [];

const codeMessage: any = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

//拦截请求
request.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

//拦截响应
request.interceptors.response.use(function (response) {
  window.localStorage.setItem(LAST_REQUEST_KEY, (Math.floor(new Date().getTime() / 1000)).toString());
  if (
    response.status === 200 ||
    response.status === 202 ||
    response.status === 304
  ) {
    // 下载文件
    if (response.config.responseType === 'blob') {
      return response;
    }
    // code和status都正常
    if (response.data?.code === SUCCESS_STATUS_CODE) {
      return response.data;
    }
    if (response.data?.code === 403) {
      goLogin();
      return response.data;
    }
  }
  const apiUrl = response.config.url || '';
  if (!MASKING_ERROR_API.includes(apiUrl)) {
    // code和status有异常的情况
    ProNotification.warning({
      message: response.data?.message || codeMessage[response.status] || '状态异常',
      description: response.data?.code === 'ERR-APP_10000' ? `联系管理员时可提供当前id编号：${response.data?.data}` : undefined,
    });
  }
  return response.data;
}, function (error) {
  // 登录信息异常
  if (error.response.status === 401 || error.response.status === 403) {
    ProNotification.warning({
      message: error.response?.data?.message,
    });
    goLogin();
  }
  ProNotification.warning({
    message: error.response?.data?.message || codeMessage[error.response.status] || '状态异常',
    description: error.response.data?.error,
  });
  return error.response?.data;
});

export default request;
